/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_verify_identity_description = /** @type {(inputs: {}) => string} */ () => {
	return `Para completar tu registro y acceder a todas las funciones, necesitas verificar tu identidad.`
};

const en_verify_identity_description = /** @type {(inputs: {}) => string} */ () => {
	return `To complete your registration and access all features, you need to verify your identity.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const verify_identity_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.verify_identity_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("verify_identity_description", locale)
	if (locale === "es") return es_verify_identity_description(inputs)
	return en_verify_identity_description(inputs)
};
export { verify_identity_description as "verify_identity.description" }